import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { Fs2faVerificationModule } from '@firestitch/2fa';
import { FsCheckboxGroupModule } from '@firestitch/checkboxgroup';
import { FsDateModule } from '@firestitch/date';
import { FsFormModule } from '@firestitch/form';
import { FsHtmlRendererModule } from '@firestitch/html-editor';
import { FsLabelModule } from '@firestitch/label';
import { FsListModule } from '@firestitch/list';
import { FsPasswordModule } from '@firestitch/password';






import { TermsDisplayComponent } from './components';
import { TermsRoutingModule } from './terms-routing.module';
import {
    CadPadTermsComponent, OrganizationTermsComponent, ParentTermsComponent,
    TermsComponent, UsdPadTermsComponent,
} from './views';


@NgModule({
    imports: [
    FormsModule,
    RouterModule,
    CommonModule,
    MatCardModule,
    MatCheckboxModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FsLabelModule,
    FsHtmlRendererModule,
    FsPasswordModule,
    FsListModule,
    Fs2faVerificationModule,
    FsFormModule,
    FsCheckboxGroupModule,
    FsDateModule,
    TermsRoutingModule,
    TermsComponent,
    ParentTermsComponent,
    TermsDisplayComponent,
    OrganizationTermsComponent,
    CadPadTermsComponent,
    UsdPadTermsComponent,
],
})
export class TermsModule {
}
